import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LinkItemLocationToDeliveryAddressMutationVariables = Types.Exact<{
  delivery_address_id: Types.Scalars['ID'];
  item_location_id: Types.Scalars['ID'];
}>;


export type LinkItemLocationToDeliveryAddressMutation = { __typename?: 'Mutation', linkItemLocationToDeliveryAddress: { __typename?: 'EventDeliveryAddress', id: string, name?: string | null, event_id?: string | null, is_event_default: boolean, linked_item_location_count: number } };


export const LinkItemLocationToDeliveryAddressDocument = gql`
    mutation LinkItemLocationToDeliveryAddress($delivery_address_id: ID!, $item_location_id: ID!) {
  linkItemLocationToDeliveryAddress(
    delivery_address_id: $delivery_address_id
    item_location_id: $item_location_id
  ) {
    id
    name
    event_id
    is_event_default
    linked_item_location_count
  }
}
    `;
export type LinkItemLocationToDeliveryAddressMutationFn = Apollo.MutationFunction<LinkItemLocationToDeliveryAddressMutation, LinkItemLocationToDeliveryAddressMutationVariables>;

/**
 * __useLinkItemLocationToDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useLinkItemLocationToDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkItemLocationToDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkItemLocationToDeliveryAddressMutation, { data, loading, error }] = useLinkItemLocationToDeliveryAddressMutation({
 *   variables: {
 *      delivery_address_id: // value for 'delivery_address_id'
 *      item_location_id: // value for 'item_location_id'
 *   },
 * });
 */
export function useLinkItemLocationToDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<LinkItemLocationToDeliveryAddressMutation, LinkItemLocationToDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkItemLocationToDeliveryAddressMutation, LinkItemLocationToDeliveryAddressMutationVariables>(LinkItemLocationToDeliveryAddressDocument, options);
      }
export type LinkItemLocationToDeliveryAddressMutationHookResult = ReturnType<typeof useLinkItemLocationToDeliveryAddressMutation>;
export type LinkItemLocationToDeliveryAddressMutationResult = Apollo.MutationResult<LinkItemLocationToDeliveryAddressMutation>;
export type LinkItemLocationToDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<LinkItemLocationToDeliveryAddressMutation, LinkItemLocationToDeliveryAddressMutationVariables>;